// extracted by mini-css-extract-plugin
module.exports = {"desktop":"BodySubSecurity_desktop_3GSVE","mobile":"BodySubSecurity_mobile_3BAjx"};